import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { HcDropdown } from '@hotmart-org-ca/cosmos-web/dist/react/hc-dropdown';
import { useEventListener } from 'src/core/hooks/useEventListener';
import { DropdownHeader } from './dropdownHeader';
import { DropdownItem } from './dropdownItem';
import { DropdownItemLink } from './dropdownItemLink';
export function Dropdown({ controls, children, className, position = 'bottom', ...rest }) {
    const ref = useRef(null);
    useEventListener('openDropdown', (event) => {
        if (ref.current && event.target.contains(ref.current)) {
            ref.current.updatePlacement?.();
        }
    });
    return (_jsxs(HcDropdown, { position: position, className: className, ref: ref, ...rest, children: [_jsx("div", { slot: "controls", children: controls }), children] }));
}
Dropdown.Item = DropdownItem;
Dropdown.Link = DropdownItemLink;
Dropdown.Header = DropdownHeader;
